(function(){
'use strict';
if(window.__elzPc)return;window.__elzPc=true;
var $=function(s,r){return(r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
function toast(m,o){if(window.elzToast)window.elzToast(m,o||{})}
function pick(sw){
  var card=sw.closest('.elz-pc');if(!card)return;
  $$('.elz-sw',card).forEach(function(x){x.classList.toggle('is-on',x===sw)});
  var img=$('.elz-pc__img--main',card);
  if(img&&sw.dataset.img){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=sw.dataset.img}
  card.classList.add('is-swatched');
  var url=(card.dataset.url||'')+'?variant='+sw.dataset.vid;
  $$('[data-pc-link]',card).forEach(function(a){a.setAttribute('href',url)});
  var avail=sw.dataset.avail!=='false';
  var buy=$('[data-pc-buy]',card);
  if(buy){buy.dataset.vid=sw.dataset.vid;buy.disabled=!avail;buy.classList.toggle('is-off',!avail);buy.textContent=avail?'Buy Now':'Sold Out'}
}
document.addEventListener('mouseover',function(e){var sw=e.target.closest&&e.target.closest('.elz-sw');if(sw&&!sw.classList.contains('is-on'))pick(sw)});
document.addEventListener('click',function(e){
  var sw=e.target.closest('.elz-sw');
  if(sw){e.preventDefault();pick(sw);return}
  var b=e.target.closest('[data-pc-buy]');
  if(!b||b.disabled)return;
  e.preventDefault();
  b.classList.add('is-loading');
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:parseInt(b.dataset.vid,10),quantity:1})})
    .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
    .then(function(x){
      if(!x.ok||x.d.status)throw new Error(x.d.description||x.d.message||'Could not add this item.');
      toast('Taking you to checkout\u2026',{type:'info',title:'Buy now'});
      location.href='/checkout';
    })
    .catch(function(er){toast(er.message||'Could not add this item.',{type:'error',title:'Could not buy'});b.classList.remove('is-loading')});
});
})();
